export default "__VITE_ASSET__BtAbkjV7__"